declare global {
  interface Window {
    adsbygoogle: any[];
    __adSenseLoaded?: boolean;
  }
}

const ADSENSE_SRC = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

function getExistingScript(): HTMLScriptElement | null {
  const scripts = Array.from(document.scripts);
  return scripts.find(s => s.src.startsWith(ADSENSE_SRC)) || null;
}

let loaderPromise: Promise<void> | null = null;

export function loadAdSense(clientId: string): Promise<void> {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }

  if (window.__adSenseLoaded) {
    window.adsbygoogle = window.adsbygoogle || [];
    return Promise.resolve();
  }

  if (loaderPromise) {
    return loaderPromise;
  }

  loaderPromise = new Promise<void>((resolve, reject) => {
    try {
      window.adsbygoogle = window.adsbygoogle || [];

      const existing = getExistingScript();
      if (existing) {
        existing.addEventListener('load', () => {
          window.__adSenseLoaded = true;
          resolve();
        });
        existing.addEventListener('error', () => reject(new Error('AdSense script failed to load')));
        // If it already completed loading before we attached listeners
        if ((existing as any).readyState === 'complete') {
          window.__adSenseLoaded = true;
          resolve();
        }
        return;
      }

      const script = document.createElement('script');
      script.async = true;
      script.src = `${ADSENSE_SRC}?client=${encodeURIComponent(clientId)}`;
      script.crossOrigin = 'anonymous';
      script.addEventListener('load', () => {
        window.__adSenseLoaded = true;
        resolve();
      });
      script.addEventListener('error', () => reject(new Error('AdSense script failed to load')));
      document.head.appendChild(script);
    } catch (err) {
      reject(err as Error);
    }
  });

  return loaderPromise;
}

export function isCrawlerUserAgent(ua: string | null | undefined): boolean {
  if (!ua) return false;
  return /bot|googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|facebookexternalhit|twitterbot|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest|slackbot|vkShare|W3C_Validator|whatsapp|telegrambot/i.test(ua);
}


